module.exports = __webpack_public_path__ + "img/symbol_12.5fa2ba16.png";